import { useEffect, type PropsWithChildren } from 'react';
import { startObservability } from '@/lib/observability';

/**
 * Empty on purpose: no session, no query cache and no realtime; it only starts
 * PostHog after the first paint.
 */
export function AppProvider({ children }: PropsWithChildren) {
  useEffect(() => startObservability(), []);

  return children;
}
